import * as React from 'react';
import { useState, useEffect } from "react";
import MuiDrawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import FormControl from "@mui/material/FormControl";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, onSnapshot, query, addDoc, where, orderBy, doc, updateDoc, limit } from 'firebase/firestore'

// Connect to current firebase project
const firebaseApp = initializeApp({
    apiKey: "AIzaSyBamRPS6NxxPg7lplFrxZd36fLWg9ZUTDY",
    authDomain: "ambient-systems.firebaseapp.com",
    databaseURL: "https://ambient-systems-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "ambient-systems",
    storageBucket: "ambient-systems.appspot.com",
    messagingSenderId: "1001740093061",
    appId: "1:1001740093061:web:b516ca06c0e80199b90bec"
  });
  const firestore = getFirestore(firebaseApp);
  
  /* Identify the current user */
  const user_email = window.localStorage.getItem('user_email');

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      '& .MuiDrawer-paper': {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        boxSizing: 'border-box',
        ...(!open && {
          overflowX: 'hidden',
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          width: theme.spacing(7),
          [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
          },
        }),
      },
    }),
  );

const drawerWidth = 220;

export default function MLRequestsPage() {
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const toggleDrawer = () => {
        setOpen(!open);
    };

    const [payWall, setPayWall] = useState(false)
    useEffect(() => {
        const authQuery = query(
        collection(firestore, 'users'),
        where('username', '==', user_email),
        );
        onSnapshot(authQuery, snapshot => {
            const t = (snapshot.docs.map(doc => ({ data: doc.data().isUpgrade })))
            if (!t[0].data) {
                setPayWall(true)
            }
        })
    }, [])

    const [instance, setInstance] = useState([])
    const [model, setModel] = useState([])
    const [view, setView] = useState(false)
    const [message, setMessage] = useState([])

    useEffect(() => {
        const modelQuery = query(
          collection(firestore, 'models'),
          where('email', '==', user_email),
          where('status', '==', 'In progress'),
          orderBy("modelId")
        );
        const unsubscribe = onSnapshot(modelQuery, snapshot => {
          setInstance(snapshot.docs.map(doc => ({id: doc.id, data: doc.data() })))
        })
    
        return () => {
          unsubscribe()
        }
    }, [])

    useEffect(() => {
        const requestQuery = query(
          collection(firestore, 'modelRequestStage'),
          where('email', '==', user_email),
          where('modelId', '==', Number(model)),
          orderBy("date")
        );
        const unsubscribe = onSnapshot(requestQuery, snapshot => {
            setMessage(snapshot.docs.map(doc => ({id: doc.id, data: doc.data() })))
        })
    
        return () => {
          unsubscribe()
        }
    }, [model])

    function handleRequest() {
        if (model == '') {
            alert("Please choose one!")
        } else {
            setView(true)
        }
    }

    const closeView = () => {
        setView(false)
    }

    return (
        <Box sx={{ display: 'flex', height: '100%'}}>
            {/* Side bar layout */}
            <Drawer variant="permanent" open={open} >
                <Toolbar
                    sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    px: [1],
                    height: 66,
                    }}
                >
                    <IconButton onClick={toggleDrawer} sx={{ mr: 1 }}>
                        {open ?<KeyboardDoubleArrowLeftIcon /> : <KeyboardDoubleArrowRightIcon />}
                    </IconButton>
                </Toolbar>

                <Divider />

                {/* Navigations to different pages */}
                <List component="nav">
                    <ListItemButton href="/Dashboard/ML" >
                        <ListItemIcon>
                        <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Summary" />
                    </ListItemButton>

                    <ListItemButton href="/Dashboard/ML/Requests">
                        <ListItemIcon>
                        <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Requests" />
                    </ListItemButton>

                    <ListItemButton href="/Dashboard/ML/Assembly" >
                        <ListItemIcon>
                        <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Assembly Line" />
                    </ListItemButton>

                    <ListItemButton href="/Dashboard/ML/Active">
                        <ListItemIcon>
                        <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Active" />
                    </ListItemButton>

                    <ListItemButton href="/Dashboard/Output" >
                        <ListItemIcon>
                        <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Output" />
                    </ListItemButton>

                    <ListItemButton>
                        <ListItemIcon>
                        <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Destination" />
                    </ListItemButton>
                </List>
            </Drawer>

            {payWall? (
            <Box sx={{ height: '100%', width: '100%' }}  display="flex" justifyContent="center" alignItems="center">
                This service is limited to PRO version. Please upgrade your version by clicking the "UPGRADE" button on the top right.
            </Box>
            ) : (  
            <Box>
                {/* Title */}
                <Box sx={{ width: '100%' }}>
                    {/* Title */}
                    <Typography
                        component="h1"
                        variant="subtitle1"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, mt: 3, ml: 8 }}
                        >
                        Ambient / Machine Learning / Requests
                    </Typography>
                    <Typography
                        component="h1"
                        variant="h4"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, ml: 8, mb: 2 }}
                        >
                        Requests
                    </Typography>
                </Box>

                <Box sx={{ ml: 8, mt: 3, display: 'flex' }}>
                    <Typography
                        component="h1"
                        variant="subtitle1"
                        color="inherit"
                        noWrap
                        sx={{ mt: 1 }}
                        >
                        Choose one of your models in this stage and check the status: 
                    </Typography>
                    <FormControl sx={{ ml: 2, minWidth: 200 }} variant= "standard">
                        <Select native defaultValue="" label="Feed" disableUnderline
                            theme={theme}
                            sx={{
                                borderRadius: 25,
                                backgroundColor: theme.palette.background.default,
                                padding: "6px 15px",
                            }}
                            value={model}
                            onChange={(e) => {setModel(e.target.value)}}>
                            
                            <option aria-label="None" value="">Your Model in this stage</option>
                            {instance?.map((row) => (
                                <option value={row.data.modelId}>{row.data.name}</option>
                            ))}
                        </Select>
                    </FormControl>
                    <Box>
                        <Button
                            variant="contained"
                            color="secondary"
                            sx={{ ml: 3, mt: 0.5, borderRadius: 5 }}
                            position="absolute"
                            onClick={handleRequest}
                        >
                            View
                        </Button>
                    </Box>
                </Box>

                <Box sx={{ ml: 8, mt: 3 }}>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 800 }} aria-label="model requests table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="right">Model ID</TableCell>
                          <TableCell align="right">Model Name</TableCell>
                          <TableCell align="right">Data Expert</TableCell>
                          <TableCell align="right">Date Requested</TableCell>
                          <TableCell align="right">Model Status</TableCell>
                          <TableCell align="right">Feed ID</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {instance?.map((row) => (
                          <TableRow
                            key={row.data.modelId}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell component="th" scope="row">
                              {row.data.modelId}
                            </TableCell>
                            <TableCell align="right">{row.data.name}</TableCell>
                            <TableCell align="right">{row.data.dataExpert}</TableCell>
                            <TableCell align="right">{row.data.dateRequested.toDate().toString()}</TableCell>
                            <TableCell align="right">{row.data.status}</TableCell>
                            <TableCell align="right">{row.data.feed}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Dialog open={view} onClose={closeView} maxWidth={"md"} fullWidth={true}>
                    <DialogTitle>Message from Expert</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            The expert you assigned may leave some message here. Please check.
                        </DialogContentText>

                        <Box sx={{ mt: 5, mb: 3, ml: 3 }}>
                            <List>
                            {message?.map((row) => (
                                <ListItemText primary={row.data.content} secondary={row.data.date.toDate().toString()} />
                            ))}   
                            </List>          
                        </Box>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={closeView}>Close</Button>
                    </DialogActions>
                </Dialog>
            </Box>
            )}
        </Box>
    )
}